import useAuth from "./../hooks/useAuth";
import { useLocation, Navigate } from "react-router-dom";

export default function RequireAuth({ children }) {
  const { authed } = useAuth();
  const location = useLocation();

  return authed === true ? (
    children
  ) : (
    <Navigate to="/login" replace state={{ path: location.pathname }} />
  );
}
